import { call, put, takeLatest } from "redux-saga/effects";

import { getCompanyPortalActivityLogs } from "../../../network/apis/companyPortalDashboard";
import { showErrorMsg } from "../../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

function* getCompanyActivityLogsSaga({ payload }) {
  try {
    const response = yield call(getCompanyPortalActivityLogs, payload);
    const data = response.data?.data;
    yield put(
      actions.getCompanyActivityLogsResponse({
        list: Array.isArray(data) ? data : [],
        meta: {
          currentPage: +response.headers["current-page"] || 1,
          count: +response.headers["total-count"] || 0,
          pages: +response.headers["total-pages"] || 1,
        },
      }),
    );
  } catch (error) {
    yield put(actions.getCompanyActivityLogsFailure());
    const message = error.response?.data?.message;
    if (message) {
      yield call(showErrorMsg, message);
    }
  }
}

export default function* companyActivityLogsSagas() {
  // Latest wins — a slower earlier search must not overwrite newer results.
  yield takeLatest(
    types.GET_COMPANY_ACTIVITY_LOGS_REQUEST,
    getCompanyActivityLogsSaga,
  );
}
